var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-case"},[_c('img',{staticClass:"pic1",attrs:{"referrerpolicy":"no-referrer","src":require("@/assets/project-case/banner.png")}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }